export const ELEMENTS_WIDTH = '500px'
